import { __rest } from "tslib";
import * as React from "react";
import { useToast } from "../../components/hooks/use-toast";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport, } from "../../components/ui/toast";
export const Toaster = () => {
    const { toasts } = useToast();
    return (React.createElement(ToastProvider, null,
        toasts.map((_a) => {
            var { id, title, description, action } = _a, props = __rest(_a, ["id", "title", "description", "action"]);
            return (React.createElement(Toast, Object.assign({ key: id }, props),
                React.createElement("div", { className: "grid gap-1" },
                    title && React.createElement(ToastTitle, null, title),
                    description && React.createElement(ToastDescription, null, description)),
                action,
                React.createElement(ToastClose, null)));
        }),
        React.createElement(ToastViewport, null)));
};
//# sourceMappingURL=toaster.js.map